import { ROUTES_UPGRADE_TO_PERFORMANCE } from '@/constants/routes';

export default {
    path: '/upgrade-to-performance',
    name: ROUTES_UPGRADE_TO_PERFORMANCE,
    component: () => import(/*webpackChunkName: 'upgrade-to-performance'*/ '@/views/UpgradeToPerformance.vue')
};
